import { computed, ref, watch } from 'vue';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars
const useCalendarPeriod = (props, { emit }) => {
  const calendarPeriodWrapper = ref<HTMLElement | null>(null);

  // ----------------------------------------
  // computed
  const slot = computed({
    get() {
      return props.selectedSlot;
    },

    set(value: string) {
      emit('selectedSlot', value);
    },
  });

  watch(
    () => props.timeOptions,
    () => {
      if (calendarPeriodWrapper.value !== null) {
        calendarPeriodWrapper.value.scrollTop = 0;
      }
    }
  );

  return {
    calendarPeriodWrapper,
    slot,
  };
};

export default useCalendarPeriod;
